// context/index.js
import React, { createContext, useState, useEffect } from 'react';
import summaryApi from '../common/index';

const Context = createContext(null);

export const ContextProvider = ({ children }) => {
  // Global wishlist state
  const [wishlistedItems, setWishlistedItems] = useState(new Set());

  // Global cart state
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);

  // Fetch wishlist from API
  const fetchWishlist = async () => {
    try {
      
      const res = await fetch(summaryApi.getWishlistProducts.url, {
        method: summaryApi.getWishlistProducts.method,
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await res.json();
      if (data.success) {
        const wishlistIds = new Set(data.data.map(item => item.productId));
        setWishlistedItems(wishlistIds);
      }
    } catch (err) {
      console.error('Failed to load wishlist:', err);
    }
  };

  // Add / Remove product to wishlist
  const toggleWishlistItem = async (productId) => {
    if (!productId) return;

    const isWishlisted = wishlistedItems.has(productId);
    const url = isWishlisted ? summaryApi.removeWishlistProduct.url : summaryApi.addToWishlist.url;
    const method = isWishlisted ? summaryApi.removeWishlistProduct.method : summaryApi.addToWishlist.method;

    try {
      const res = await fetch(url, {
        method,
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productId }),
      });
      const data = await res.json();

      if (data.success) {
        setWishlistedItems(prev => {
          const newSet = new Set(prev);
          if (isWishlisted) newSet.delete(productId);
          else newSet.add(productId);
          return newSet;
        });
      } else {
        console.error('Could not update wishlist');
      }
    } catch (err) {
      console.error('Could not update wishlist:', err);
    }
  };

  // Fetch cart items from API
  const fetchCartItems = async () => {
    try {
      const res = await fetch(summaryApi.addToCartProductView.url, {
        method: summaryApi.addToCartProductView.method,
        credentials: 'include',
      });
      const data = await res.json();
      if (data.success) setCartItems(data.data || []);
    } catch (err) {
      console.error('Failed to load cart items:', err);
    }
  };

  // Fetch cart count
  const fetchUserAddToCart = async () => {
    try {
      const res = await fetch(summaryApi.getCartCount.url, {
        method: summaryApi.getCartCount.method,
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await res.json();
      if (data.success) setCartCount(data.count || 0);
    } catch (err) {
      console.error('Failed to fetch cart count', err);
    }
  };

  useEffect(() => {
    fetchWishlist();
    fetchCartItems();
    fetchUserAddToCart();
  }, []);

  return (
    <Context.Provider
      value={{
        wishlistedItems,
        toggleWishlistItem,
        cartItems,
        setCartItems,
        cartCount,
        fetchUserAddToCart,
        fetchWishlist,
        fetchCartItems,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default Context;
